import React, { useState, useEffect, useRef, useCallback } from 'react';
import {Modal} from 'react-bootstrap';
import Select from 'react-select';
import { useDropzone } from 'react-dropzone';
import execAjax from './execAjax';
import TextField from './Textfield';
import Button from './Button';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import config from "./../../config";
import { create } from './v4/BackendProvider';
import './UploadModal.css';


var imm = require('immutable');
var cx = require('classnames');

const modalStyle = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1040,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        overflowY: 'auto',
        padding: '20px 0',
    },
    modal: {
        zIndex: 1050,
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '4px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        width: '70%',
        maxWidth: '90%'
    },
    header: {
        borderBottom: '1px solid #dee2e6',
        padding: '1rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    title: {
        margin: 0,
        fontSize: '1.25rem'
    },
    closeButton: {
        border: 'none',
        background: 'none',
        fontSize: '1.5rem',
        cursor: 'pointer'
    },
    body: {
        padding: '1rem'
    },
    footer: {
        borderTop: '1px solid #dee2e6',
        padding: '1rem',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    button: {
        padding: '0.375rem 0.75rem',
        backgroundColor: '#6c757d',
        color: 'white',
        border: 'none',
        borderRadius: '0.25rem',
        cursor: 'pointer'
    }
};

const FailedRowsTable = ({ rows, message }) => {
    return (
        <div className="col-md-12">
            <div className="row">
                <div className="col-md-12">
                    <div className="alert alert-danger">
                        {message}
                    </div>
                    <div className="alert alert-danger">
                        Below is the list of failed rows along with failure reason. Please review them and reupload if necessary.
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <table className="table table-bordered">
                        <thead>
                        <tr>
                            <td>Row</td>
                            <td>Reason</td>
                        </tr>
                        </thead>
                        <tbody>
                        {rows.map((row, index) => (
                            <tr key={index}>
                                <td>{row.key}</td>
                                <td>{row.error}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

const Preview = ({ data, columns, templates, tfields, skiprows, show, url, url_progress, onUploadSuccess, childProps }) => {
    const [state, setState] = useState({
        data: imm.Map(),
        metadata: imm.Map({skiprows: 0, newname: ''}),
        savemode: '',
        tfields: imm.Map(tfields || {}),
        errormsg: '',
        errorfields: [],
        failmsg: '',
        failedrows: [],
        numcols: 0,
        toastr: false,
        defaults: {}
    });

    useEffect(() => {
        setState(prev => ({
            ...prev,
            tfields: imm.Map(tfields || {})
        }));
    }, [tfields]);

    useEffect(() => {
        if (state.savemode) {
            execSave();
        }
    }, [state.savemode]);

    const handleSelectChange = (key, value) => {
        const val = value.value;
        setState(prev => ({
            ...prev,
            data: prev.data.set(key, val)
        }));
    };

    const handleTemplateChange = (key, value) => {
        const val = value.value;
        let newdata = state.data;
        state.tfields.get(val).forEach(row => {
            const k = row.ATRORDERNBR-1;
            newdata = newdata.set(k, row.ATRTARGETFIELD);
        });

        setState(prev => ({
            ...prev,
            data: newdata,
            metadata: prev.metadata.set(key, val).set('skiprows', skiprows[val])
        }));
    };

    const handleMetaChange = (key, value) => {
        setState(prev => ({
            ...prev,
            metadata: prev.metadata.set(key, value)
        }));
    };

    const handleSave = () => {
        setState(prev => ({
            ...prev,
            savemode: 'uploadsave'
        }));
    };

    const handleUpload = () => {
        setState(prev => ({
            ...prev,
            savemode: 'uploadonly'
        }));
    };

    const execSave = () => {
        const params = {
            data: {
                columns: state.data.toJS(),
                metadata: state.metadata.toJS(),
                mode: state.savemode
            }
        };
        console.log("Sending params:", params);
        create(url, params, childProps)
            .then((response) => {
                console.log("Full response:", response);
                console.log("Response data:", response.data);
                console.log("Response message:", response.data?.msg);
                
                // Check if response and response.data exist
                if (!response || !response.data) {
                    console.error("Invalid response structure:", response);
                    toast.error("Invalid response from server");
                    return;
                }

                // Show success message with proper fallback
                const successMessage = response.data.msg || "Upload completed successfully";
                toast.success(successMessage, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                
                let resp = state.defaults;
                if (response.data.response !== undefined) {
                    resp = response.data.response;
                }

                onUploadSuccess(resp);

                setState(prev => ({
                    ...prev,
                    data: imm.Map(prev.defaults),
                    modalIsOpen: false,
                    savemode: ''
                }));
                
            })
            .catch((err) => {
                console.log("Error details:", err);
                console.log("Error message:", err.message);
                console.log("Error response:", err.response);
                
                // Show error message with proper fallback
                const errorMessage = err.message || err.response?.data?.message || "An error occurred during upload";
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                
                const result = err.msg;
                let flds = [];
                if (result !== undefined && result.fields !== undefined) {
                    flds = result.fields;
                }
                setState(prev => ({
                    ...prev,
                    errorfields: flds,
                    savemode: ''
                }));
            });
    };

    if (!show) return null;

    if (state.failedrows?.length > 0) {
        return <FailedRowsTable rows={state.failedrows} message={state.failmsg} />;
    }
console.log("DATA", data);
    if (!data || !Array.isArray(data) || data.length === 0) {
        return (
            <div className="col-md-12">
                <div className="alert alert-warning">
                    No data available to preview. Please upload a file first.
                </div>
            </div>
        );
    }

    const temploptions = Object.entries(templates).map(([i, label]) => ({
        value: i,
        label
    }));

    const selectValue = temploptions.find(opt => opt.value === state.metadata.get('templates')) || {value: 0, label: '--'};
console.log(state.metadata.toJS());
    return (
        <div className="col-md-12">
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                style={{ zIndex: 9999 }}
            />
            <div className="row">
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-12">
                            <label
                                className="col-sm-4 control-label"
                                htmlFor="templates">Load Existing Template (optional):
                            </label>
                            <div className="col-sm-8">
                                <Select
                                    label='Load existing template:'
                                    options={temploptions}
                                    name="templates"
                                    id='templates'
                                    value={selectValue}
                                    onChange={(value) => handleTemplateChange('templates', value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <label
                                className="col-sm-4 control-label"
                                htmlFor="templates">Skip first number of rows (optional):
                            </label>
                            <div className="col-sm-8">
                                <TextField
                                    type='text'
                                    value={state.metadata.get('skiprows')}
                                    placeholder="0"
                                    onChange={(value) => handleMetaChange('skiprows', value)}
                                    className="form-control"
                                />
                            </div>
                            <div className="col-sm-4">
                            </div>
                            <div className="col-sm-8">
                                <Button bsStyle="primary" value="Upload only" onClick={handleUpload}/>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-12">
                            <label
                                className="col-sm-4 control-label"
                                htmlFor="templates">Enter Name of the new Template to save:
                            </label>
                            <div className="col-sm-8">
                                <TextField
                                    type='text'
                                    value={state.metadata.get('newname')}
                                    placeholder="New Template"
                                    onChange={(value) => handleMetaChange('newname', value)}
                                    className="form-control"
                                />
                            </div>
                            <div className="col-sm-4">
                            </div>
                            <div className="col-sm-8">
                                <Button bsStyle="default" value="Upload and Save as Template" onClick={handleSave}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="alert alert-info">
                Please select data columns below or select existing Template if available.
            </div>
            <div className="row">
                <div className="col-md-12">
                    <table className="table table-bordered">
                        <thead>
                        <tr>
                            {data[0].map((row, index) => {
                                const options = Object.entries(columns).map(([i, label]) => ({
                                    value: i,
                                    label
                                }));
                                const selectVal = options.find(opt => opt.value === state.data.get(index)) || {value: 0, label: '--'};
                                return (
                                    <td key={index}>
                                        <Select
                                            options={options}
                                            value={selectVal}
                                            onChange={(value) => handleSelectChange(index, value)}
                                        />
                                    </td>
                                );
                            })}
                        </tr>
                        </thead>
                        <tbody>
                        {data.map((row, index) => (
                            <tr key={index} className={cx(index >= state.metadata.get('skiprows') ? "" : "upload-danger")}>
                                {row.map((col, i) => (
                                    <td key={i}>{col}</td>
                                ))}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

const UploadModal = ({ modalIsOpen, onHide, onUploadSuccess, modalTitle, url_upload, url_confirm, url_progress, childProps }) => {
    const [state, setState] = useState({
        files: [],
        showPreview: false,
        preview: [],
        metadata: {
            columns: {},
            templates: {},
            tfields: {},
            skiprows: {}
        },
        requestRefetch: false,
        showProgress: false,
        progress: []
    });

    const refreshIntervalRef = useRef(null);

    useEffect(() => {
        return () => {
            if (refreshIntervalRef.current) {
                clearInterval(refreshIntervalRef.current);
            }
        };
    }, []);

    const handleCancel = () => {
        if (refreshIntervalRef.current) {
            clearInterval(refreshIntervalRef.current);
        }
        setState({
            showProgress: false,
            preview: [],
            showPreview: false,
            progress: []
        });
        onHide();
    };

    const onDrop = useCallback((acceptedFiles) => {
        const file = acceptedFiles[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);

        const token = localStorage.getItem('token');
        axios.post(config.apiV4.user.URL + url_upload + '?method=create', formData, {
            withCredentials: true, 
            withXSRFToken: true, 
            headers: {
                "Authorization": `Token ${token}`
            }
        })
        .then((response) => {
            if (refreshIntervalRef.current) {
                clearInterval(refreshIntervalRef.current);
            }
            setState(prev => ({
                ...prev,
                showPreview: true,
                showProgress: false,
                preview: response.data.data || [],
                metadata: {
                    columns: response.data.metadata?.columns || {},
                    templates: response.data.metadata?.templates || {},
                    tfields: response.data.metadata?.tfields || {},
                    skiprows: response.data.metadata?.skiprows || {}
                },
                requestRefetch: true
            }));
        })
        .catch((error) => {
            toast.error('Upload failed: ' + (error.response?.data?.message || 'Unknown error'));
        });
    }, [url_upload]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'text/csv': ['.csv'],
            'application/vnd.ms-excel': ['.xls'],
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
        },
        multiple: false
    });

    const onProcessing = () => {
        setState(prev => ({
            ...prev,
            showProgress: true
        }));
        refreshIntervalRef.current = setInterval(getProgress, 1000);
    };

    const getProgress = () => {
        if (!url_progress) return;
        
        const token = localStorage.getItem('token');
        const api_base = config.apiV4.user.URL;
        const url = `${api_base}/${url_progress}?method=get&authToken=${token}`;
        
        axios.get(url, {
            headers: {
                "Authorization": `Token ${token}`,
                "Accept": "application/json"
            }
        })
        .then((response) => {
            const data = response.data;
            if (data.result === "0") {
                setState(prev => ({
                    ...prev,
                    progress: data.data
                }));
            } else {
                setState(prev => ({
                    ...prev,
                    progress: []
                }));
            }
        })
        .catch((error) => {
            console.error('Progress check failed:', error);
            setState(prev => ({
                ...prev,
                progress: []
            }));
        });
    };

    if (!modalIsOpen) return null;

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                style={{ zIndex: 9999 }}
            />
            <div style={modalStyle.overlay}>
                <div style={modalStyle.modal}>
                    <div style={modalStyle.header}>
                        <h4 style={modalStyle.title}>{modalTitle}</h4>
                        <button style={modalStyle.closeButton} onClick={handleCancel}>&times;</button>
                    </div>
                    <div style={modalStyle.body}>
                        <div className="row">
                            <div className="col-md-12">
                                <div {...getRootProps()} style={{
                                    border: '2px dashed #cccccc',
                                    borderRadius: '4px',
                                    padding: '20px',
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    backgroundColor: isDragActive ? '#f8f9fa' : 'white'
                                }}>
                                    <input {...getInputProps()} />
                                    <div>
                                        {isDragActive ? (
                                            <p>Drop the file here...</p>
                                        ) : (
                                            <p>Drag and drop a CSV/Excel file here, or click to select files to upload. Wait until processing is done and preview screen opens. This may take a while</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                {state.showProgress && state.progress.data && (
                                    <div className="progress progress-striped active">
                                        <div 
                                            className="progress-bar progress-bar-success" 
                                            role="progressbar" 
                                            aria-valuenow={state.progress.data.ATRPERC}
                                            aria-valuemin="0" 
                                            aria-valuemax="100" 
                                            style={{width: state.progress.data.ATRPERC + '%'}}
                                        >
                                            <span className="sr-only">{state.progress.data.ATRPERC}% Complete (success)</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="row">
                            <Preview
                                data={state.preview || []}
                                columns={state.metadata?.columns || {}}
                                templates={state.metadata?.templates || {}}
                                tfields={state.metadata?.tfields || {}}
                                skiprows={state.metadata?.skiprows || {}}
                                show={state.showPreview}
                                url={url_confirm}
                                url_progress={url_progress}
                                onUploadSuccess={onUploadSuccess}
                                childProps={childProps}
                            />
                        </div>
                    </div>
                    <div style={modalStyle.footer}>
                        <button style={modalStyle.button} onClick={handleCancel}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UploadModal;
